import React from 'react';
import { Link } from 'react-router';
import '../../public/css/media/_signup-success.scss';
import Footer from './Layout/Footer/Footer';
import DashboardAddress from './Dashboard/DashboardAddress';
import RequiredModal from './DashboardFiles/RequiredModal';
import { v4 as uuid } from 'uuid';
import { netcoreScript } from '../utils/utils';
import { filterWarehouse } from '../utils/whiteListed';
import { warehouseAND } from '../constants/warehouseCode';
import { handleAppUrl } from '../utils/urls';

const createReactClass = require('create-react-class');
const SignupSuccess = createReactClass({
  getInitialState: function () {
    return {
      phone_number: '',
      incompleteInfo: false,
    }
  },
  componentDidMount() {
    window.scrollTo(0, 0);

    // <!-- Lightning Bolt Begins -->
    const lbscript = document.createElement("script");
    lbscript.type = "text/javascript";
    lbscript.src = "/js/lightningbolt.js";
    lbscript.async = true;
    document.body.appendChild(lbscript);

    const lbscript1 = document.createElement("script");
    lbscript1.type = "text/javascript";
    lbscript1.setAttribute('id', 'lightning_bolt');
    lbscript1.src = "//cdn-akamai.mookie1.com/LB/LightningBolt.js";
    lbscript1.async = true;
    document.body.appendChild(lbscript1);
    // <!-- Lightning Bolt Ends -->

    const grabKey = localStorage.getItem('grabKey');

    // Append img tag with src coming from Grab
    const firePixel = (r) => {
      let img = document.createElement("img");
      img.src = grabKey;
      document.body.appendChild(img)
    }

    if (!!grabKey) {
      firePixel()
    }
  },
  componentWillMount() {
    const token = localStorage.jwtToken;
    this.props.signedIn(token);
    localStorage.setItem("TourFinish", "false");
    this.props.getCopyrightYear();
    // <!-- NetCore Script -->
    const accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '' ;
    window.smartech && netcoreScript(accountNumber);
    // <!-- NetCore Script -->    
  },
  componentWillReceiveProps(nextProps) {
    let title = "Hello ";
    title += this.props.login.fetched ? nextProps.login.login.party.first_name:"";
    document.title = title;
    
    if (nextProps.login.login.party){
      if (!nextProps.login.login.party.email || !nextProps.login.login.party.phone_number){
        this.setState({incompleteInfo:true})
      }else{
        this.setState({incompleteInfo:false})
      }
    }
  },
  handleLogout() {
    localStorage.removeItem('jwtToken');
    this.props.logout();
  },
  handleTour() {
    localStorage.setItem("Tour", "true");
  },
  handleSkip() {
    localStorage.setItem("Tour", "false");
  },
  render() {
    // let warehouse = this.props.customerInfo.warehouse_fetched ? this.props.customerInfo.warehouse.data : null;
    return (

      <div>
        {/* 
        Activity name of this tag: Signup success
        URL of the webpage where the tag is expected to be placed: https://www.shippingcart.com/signup-success
        This tag must be placed between the <body> and </body> tags, as close as possible to the opening tag.
        Creation Date: 02/04/2020
        */}
        <iframe title={uuid()} src="https://9848754.fls.doubleclick.net/activityi;src=9848754;type=signu00;cat=signu0;qty=1;cost=1;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1?" width="1" height="1" frameBorder="0" style={{display: 'none'}}></iframe>
        {/*  End of Floodlight Tag: Please do not remove  */}
        {this.props.login.fetched ?
          <div id="shippingcart_app" className="header-minimal">

            <nav id="fullSidebarNav" className="sidenav">

              <a className="customer-name" data-do="hamburger" data-on="click" data-target="account">
                <span className="name-first">
                  Hello  {this.props.login.login.party.first_name}
                </span>
              </a>
              <Link to="/cart"><span>Cart</span></Link>
              <Link to="/shipment"><span>Shipments</span></Link>
              <Link to="/account"><span>Account</span></Link>
              <Link to={`${handleAppUrl()}/shipping-estimate`} target='_blank'>Get Shipping Estimate</Link>
              <Link to={`${handleAppUrl()}/track`} target='_blank'>Track Your Package</Link>
              <Link to="/logout"><span>Logout</span></Link>
            </nav>
            <header className="site-header header-minimal sign-up-success">
              <div className="container">
                <div className="logo">
                  <Link to="/home" className="clearfix">
                    <div className="main-img"></div>
                  </Link>
                </div>
                <nav className="top-nav">
                  <ul>
                    <li className="dropdown has-sub ">
                      <Link className="dropdown-toggle" data-toggle="dropdown">
                        <span className="name-first">
                          Hello {this.props.login.login.party.first_name}
                        </span>
                        <i className="fa fa-angle-down fa-fw"></i>
                      </Link>
                      <ul className="dropdown-menu sub-account2 ">
                        <li><Link to="/cart"><i className="fa fa-archive fa-fw"></i><span>Cart</span></Link></li>
                        <li><Link to="/shipment"><i className="fa fa-location-arrow fa-fw"></i><span>Shipments</span></Link></li>
                        <li><Link to="/account"><i className="fa fa-user fa-fw"></i><span>Account</span></Link></li>
                        <li className="spacer"></li>
                        <li><Link to="/home" onClick={this.handleLogout}><i className="fa fa-power-off fa-fw"></i><span>Logout</span></Link></li>
                      </ul>
                    </li>
                  </ul>
                </nav>
              </div>
            </header>
            <div className="body-wrapper signinpage">
              <section className="signup-hello">
                {localStorage.bfmSignup && <div className="back" style={{marginLeft: '5%'}}>
                  <span>&#60;</span><Link onClick={() => localStorage.removeItem('bfmSignup')} to="/buy-for-me">Back to Buy-for-me form</Link>
                </div>}
                <div className="heading">
                  <h2 className="roboto">Thank you for joining, {this.props.login.login.party.first_name}!</h2>
                  <p>Now you can shop online from {warehouseAND} and ship to your doorstep.</p>
                  <h5>Here's a quick reminder on how to ship with ShippingCart:</h5>
                </div>
                <div className="sc-addresses">
                  {this.props.customerInfo.warehouse_fetched ? filterWarehouse(this.props.customerInfo.warehouse.data, this.props.login.login.party).sort((a, b) => a.country_code > b.country_code ? 1 : -1).map((address,key) =>
                    <DashboardAddress
                      first_name={this.props.login.login.party.first_name}
                      last_name={this.props.login.login.party.last_name}
                      account_number={this.props.login.login.party.account_number}
                      key={key}
                      address={address}
                      highlightOregon={false}
                    /> )
                  : null}
                  
                </div>
                <div style={{display: "flex", justifyContent: 'center'}}>
                  <div>
                    <h4 style={{fontWeight: 'bold'}}>Your Shipping Address</h4>
                    <p>Use this as your delivery address when you checkout from {warehouseAND} online stores.</p>
                    <p>Don't forget to input your complete ShippingCart address, including your account number and phone number when you checkout.</p>
                  </div>
                </div>
              </section>
              <section className="signup-infographics">
                <div className="sc-success centered infographics">
                  <img src="/images/sc-success-shop.png" alt="Shop"/>
                  <div className="details">
                    <h5>Shop</h5>
                    <p>Shop from {warehouseAND} online stores and send it to your ShippingCart address.</p>
                    <p>Don't forget to include your account number.</p>
                  </div>
                </div>
                <div className="sc-success centered infographics">
                  <img src="/images/sc-success-accepted.png" alt="Check emaik"/>
                  <div className="details">
                    <h5>Check email</h5>
                    <p>We'll notify you via email when your package arrives at the ShippingCart warehouse.</p>
                  </div>
                </div>
                <div className="sc-success centered infographics">
                  <img src="/images/sc-success-ready.png" alt="Ready to Ship"/>
                  <div className="details">
                    <h5>Ready to Ship</h5>
                    <p>After processing, we'll notify you via email when your package is ready for checkout and shipping.</p>
                  </div>
                </div>
                <div className="sc-success centered infographics">
                  <img src="/images/sc-success-review.png" alt="Review and Pay"/>
                  <div className="details">
                    <h5>Review and Pay</h5>
                    <p>Checkout your package and pay the shipping fee.</p>
                    <p>If you have multiple packages, you can consolidate them into one shipment.</p>
                  </div>
                </div>
                <div className="sc-success centered infographics">
                  <img src="/images/sc-success-way.png" alt="Package is On Its Way"/>
                  <div className="details">
                    <h5>Package is On Its Way</h5>
                    <p>Once your payment is posted, we'll ship your package to your delivery address.</p>
                  </div>
                </div>
              </section>
              <section className="signup-tour">
                <div className="sc-success centered">
                  <div>
                    <h5>What to do next?</h5>
                    <p>We'll guide you to your Dashboard</p>
                  </div>
                  <Link to="/cart" className="sc-btn tour-btn" onClick={this.handleTour}>Take the tour</Link>
                  <Link to="/cart" className="sc-btn skip-btn" onClick={this.handleSkip}>Go to your Cart</Link>
                </div>
              </section>
            </div>

            <Footer
              currentPath={this.props.location.pathname}
              currentYear={this.props.login.year}
            />

            {this.state.incompleteInfo ? 
              <RequiredModal show={true}
              first_name={this.props.login.login.party.first_name}
              last_name={this.props.login.login.party.last_name}
              email={this.props.login.login.party.email}
              phone_number={this.props.login.login.party.phone_number}
              error={this.props.login.error && this.props.login.error.data ? this.props.login.error.data.errors : null}
    
              />
            : null}
          </div>
          : null
        }
      </div>
    )
  },
});

export default SignupSuccess;



/** WEBPACK FOOTER **
 ** ./src/components/SignupSuccess.js
 **/